import {Component, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {NotificationService} from '../../../services/notification.service';

@Component({
    selector: 'app-share-vehicle-widget',
    templateUrl: './share-vehicle-widget.component.html',
    styleUrls: ['./share-vehicle-widget.component.scss'],
    standalone: false
})
export class ShareVehicleWidgetComponent implements OnChanges {

  @Input() url: string;

  public mediums: Medium[] = [];

  constructor(@Inject(PLATFORM_ID) private platformId: object, private notificationService: NotificationService) {
  }

  /** Rebuilds the share links whenever `url` (re)resolves — some callers
   *  (e.g. ShareAdDialogComponent) bind `url` before the real value has
   *  loaded asynchronously, so building the links only once in ngOnInit
   *  would bake in `undefined` (BRIEFD-7057). */
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['url']) {
      return;
    }
    if (!this.url) {
      this.mediums = [];
      return;
    }
    this.mediums = [
      {id: 'fb', url: `https://www.facebook.com/sharer/sharer.php?u=${this.url}`},
      {id: 'email', url: `mailto:?body=${this.url}`},
      {id: 'twitter', url: `https://twitter.com/intent/tweet?text=${this.url}`},
    ];
  }

  hasShare() {
    return isPlatformBrowser(this.platformId) && navigator && (navigator as any).share;
  }

  share() {
    const shareData = {
      title: '',
      text: '',
      url: this.url,
    };

    (navigator as any).share(shareData).then(() => {
      },
      error => (
        this.notificationService.showErrorAlert()
      ));

  }
}

interface Medium {
  id: string;
  url: string;
}
